import React from 'react';
import classNames from 'classnames/bind';
import { VideoPlayer } from '@components';
import { Typography } from 'gd-design-library';
import { ImageTransformation, TRANSFORMATIONS, ProductDetailsVideoItem } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';
import styles from '../ProductStaticContent.module.scss';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsVideoItem;
}

export const Video: React.FC<Props> = ({
  productDetailsItem: {
    video: {
      title,
      video
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(productDetailsItemClassName) }>
      <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <VideoPlayer
        url={ imageTransformation.transformVideoById(
          video[0].public_id,
          [ ...ALL_IMAGES_TRANSFORMATIONS ]
        ) }
        posterUrl={ imageTransformation.transformVideoById(
          video[0].public_id,
          [ { name: TRANSFORMATIONS.VIDEO_THUMBNAIL } ]
        ) }
      />
    </div>
  );
};
